/* ============================================================
   MyPokea — Bundle bar partagé
   Persistance cross-pages via localStorage.
   Exposé via window.Bundle.
   Chaque page enregistre window._bundleSyncBadges pour mettre
   à jour les tuiles après un toggle depuis la barre.
   ============================================================ */

const BUNDLE_KEY = "mypokea-bundle";

function _altStd(name, num) {
  const parts = ['Finger puppet', 'Figurine Pokémon', 'Pokémon Kids', name || ''];
  if (num != null) parts.push('N°' + String(num).padStart(3, '0'));
  return parts.join(' | ');
}

window.Bundle = {
  _picks: [],

  _load() {
    try { this._picks = JSON.parse(localStorage.getItem(BUNDLE_KEY) || "[]"); }
    catch (e) { this._picks = []; }
  },

  _save() {
    try { localStorage.setItem(BUNDLE_KEY, JSON.stringify(this._picks)); }
    catch (e) {}
  },

  get picks() { return this._picks; },

  has(key) { return this._picks.some(p => p.key === key); },

  toggle(pick) {
    if (this.has(pick.key)) this._picks = this._picks.filter(p => p.key !== pick.key);
    else this._picks.push(pick);
    this._save();
    this.render();
    if (window._bundleSyncBadges) window._bundleSyncBadges();
  },

  remove(key) {
    this._picks = this._picks.filter(p => p.key !== key);
    this._save();
    this.render();
    if (window._bundleSyncBadges) window._bundleSyncBadges();
  },

  clear() {
    this._picks = [];
    this._save();
    this.render();
    if (window._bundleSyncBadges) window._bundleSyncBadges();
  },

  render() {
    const bar = document.getElementById("bundle-bar");
    if (!bar) return;
    const picks = this._picks;
    const count = picks.length;
    const sub = picks.reduce((s, p) => s + p.price, 0);
    const bundle = count >= 5;
    const total = bundle ? sub * 0.9 : sub;

    bar.classList.toggle("show", count > 0);

    const elCount = document.getElementById("bb-count");
    const elLabel = document.getElementById("bb-label");
    const elHint  = document.getElementById("bb-hint");
    if (elCount) elCount.textContent = count;
    if (elLabel) elLabel.textContent =
      count <= 1 ? count + " figurine sélectionnée" : count + " figurines sélectionnées";
    if (elHint) elHint.textContent =
      bundle ? "Bundle -10 % appliqué" :
      count === 0 ? "" :
      `Ajoute ${5 - count} figurine${5 - count > 1 ? "s" : ""} pour -10 %`;

    const tbox = document.getElementById("bb-thumbs");
    if (tbox) {
      const show = picks.slice(0, 6);
      const more = picks.length - show.length;
      tbox.innerHTML = show.map(p => `
        <button class="bundle-thumb" data-rm="${p.key}" title="${p.name} — retirer">
          ${p.image
            ? `<img src="${p.image}" alt="${_altStd(p.name, p.num)}" draggable="false">`
            : `<span style="font-family:var(--font-head);font-size:10px;font-weight:800;">${p.name.slice(0, 2).toUpperCase()}</span>`}
        </button>
      `).join("") + (more > 0 ? `<div class="bundle-thumb bundle-thumb-more">+${more}</div>` : "");
      tbox.querySelectorAll("[data-rm]").forEach(b => b.onclick = (e) => {
        e.stopPropagation();
        Bundle.remove(b.dataset.rm);
      });
    }

    const elTotal   = document.getElementById("bb-total");
    const elOld     = document.getElementById("bb-total-old");
    const elPill    = document.getElementById("bb-discount-pill");
    if (elTotal) elTotal.textContent = total.toFixed(2).replace(".", ",") + " €";
    if (elOld)  { elOld.style.display  = bundle ? "inline" : "none"; if (bundle) elOld.textContent = sub.toFixed(2).replace(".", ",") + " €"; }
    if (elPill) { elPill.style.display = bundle ? "inline-block" : "none"; }
  },

  _bind() {
    const clear    = document.getElementById("bb-clear");
    const checkout = document.getElementById("bb-checkout");
    if (clear)    clear.onclick    = () => Bundle.clear();
    if (checkout) checkout.onclick = async () => {
      if (!Bundle.picks.length || checkout.disabled) return;
      const prevLabel = checkout.textContent;
      checkout.disabled = true;
      checkout.textContent = "Ajout en cours…";
      const bundle = Bundle.picks.length >= 5;
      await Cart.addMany(Bundle.picks.map(p => ({
        id:      p.url ? p.url.replace(/^\/products\//, '').split('?')[0] : p.key,
        name:    p.name,
        price:   Math.round((bundle ? p.price * 0.9 : p.price) * 100) / 100,
        variant: (p.variant || p.name) + (bundle ? " · Bundle -10%" : ""),
        image:   p.image,
        bg:      p.bg,
        qty:     1,
      })));
      checkout.disabled = false;
      checkout.textContent = prevLabel;
      Bundle.clear();
      if (window.openCart) openCart();
    };
  },

  init() {
    this._load();
    this._bind();
    this.render();
  },
};

document.addEventListener("DOMContentLoaded", () => Bundle.init());
